// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')
	//const dropDownMenu   = document.getElementById('js-site-menu')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
			//dropDownMenu.classList.toggle('is-active')
		} );
	}



	// Header Scroll
	// --------------------------------------------------------------- //

	let startPos = 0;
	let header = document.getElementById('js-header');
	let triggerPos = 50;

	// init
	let scrollTop = window.pageYOffset

	if ( scrollTop < triggerPos ) {
		header.classList.remove('is-hidden')
		header.classList.remove('has-animation')
	} else {
		header.classList.add('has-animation')
	}


	window.addEventListener('scroll', function(e) {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let currentPos = scrollTop;

		if (currentPos > startPos) {
			// down
			if ( scrollTop >= triggerPos ) {
				header.classList.add('is-hidden')
				header.classList.add('has-animation')
			}
		} else {
			// up
			header.classList.remove('is-hidden')
			if ( scrollTop < triggerPos ) {
				header.classList.remove('has-animation')
			} else {
				header.classList.add('has-animation')
			}
		}
		startPos = currentPos;
	})



	// Floating Banner
	// --------------------------------------------------------------- //

	let fltngBnnrFlag = false
	const fltngBnnr = document.getElementById('js-floating-banner')
	const fltngBnnrClose = document.getElementById('js-floating-banner-close')
	const bnnrDisplayPos = 400

	if ( fltngBnnr ) {

		window.addEventListener('scroll', function(e) {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let currentPos = scrollTop;

			if (currentPos > bnnrDisplayPos) {
				if ( fltngBnnrFlag === false ) {
					fltngBnnr.classList.add('is-active')
				}
			} else {
				fltngBnnr.classList.remove('is-active')
			}
		})

		fltngBnnrClose.addEventListener('click', () => {
			fltngBnnr.classList.remove('is-active')
			fltngBnnrFlag = true
		})
	}



	// Pagetop Visible
	// --------------------------------------------------------------- //

//	function pagetopVisible() {
//		const pagetop = document.getElementById('js-pagetop')
//		let offset = window.pageYOffset
//		let docHeight = document.body.scrollHeight
//		let posMulti = .4
//
//		if ( offset > (docHeight * posMulti) ) {
//			pagetop.classList.add('is-visible')
//		} else {
//			pagetop.classList.remove('is-visible')
//		}
//	}
//
//	window.onscroll = function(e) {
//		pagetopVisible();
//	}
////	window.onresize = function(e) {
////		pagetopVisible();
////	}



	// Expert content more ( sp only )
	// --------------------------------------------------------------- //

	const contentTargets = document.querySelectorAll('.js-expert-content-more')

	for ( let i = 0; i < contentTargets.length; i++ ) {
		let targets = contentTargets[i]
		let content = targets.closest('.expert-item-content__more').previousElementSibling

		targets.addEventListener('click', () => {
			targets.classList.add('hidden')
			//content.classList.add('is-active')
			content.style.height = 'auto'
		})

	}



	// Expert filter
	// --------------------------------------------------------------- //

	const expertToggle = document.getElementById('js-expert-toggle')
	const expertContents = document.getElementById('js-expert-contents')

	if ( expertToggle ) {
		expertToggle.addEventListener('click', () => {
			expertToggle.classList.toggle('is-active')
			expertContents.classList.toggle('is-active')
		})
	}




	// Faq
	// --------------------------------------------------------------- //

	const faqToggle = document.querySelectorAll('.js-faq-question')

	for ( let i = 0; i < faqToggle.length; i++ ) {
		let target = faqToggle[i]
		let content = target.closest('.faq-item__header').nextElementSibling

		target.addEventListener('click', () => {
			target.classList.toggle('is-active')
			content.classList.toggle('is-active')
			content.style.height = 'auto'
		})
	}



	// Case More ( mobile only )
	// --------------------------------------------------------------- //

	const caseLoop = document.getElementById('js-case-loop')
	const caseButton = document.getElementById('js-case-more')

	if ( caseButton ) {
		caseButton.addEventListener('click', function() {
			caseButton.classList.add('hidden')
			caseLoop.classList.add('is-active')
			//dropDownMenu.classList.toggle('is-active')
		} );
	}



	// Case Swiper ( pc only )
	// --------------------------------------------------------------- //

	let caseFlag = document.getElementById('js-case-swiper');

	// swiper 部分
	let caseSwiper;

	const breakpointChecker = function() {
		if ( breakpoint.matches === false ) {
			if ( caseSwiper !== undefined ) caseSwiper.destroy( true, true );
			return;

		} else if ( breakpoint.matches === true ) {
			return enableSwiper();

		}
	};

	const enableSwiper = function() {
		caseSwiper = new Swiper ('#js-case-swiper', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			observer: true,
			observeParents: true,
		} );
	};

	if ( caseFlag ) {
		breakpoint.addListener(breakpointChecker);

		breakpointChecker();
	}



	// Form script
	// --------------------------------------------------------------- //

//	let checkboxes = document.querySelectorAll('.is-themes input[type="checkbox"]');
//
//	checkboxes.forEach(function(checkbox) {
//		checkbox.addEventListener('change', function() {
//			themesCheckFunc( checkboxes, checkbox );
//		});
//		themesCheckFunc( checkboxes, checkbox );
//	});
//
//	function themesCheckFunc( events, event ) {
//		let checkedCount = document.querySelectorAll('.is-themes input[type="checkbox"]:checked').length;
//		let checkeParent = event.closest('.js-check-limit');
//
//		events.forEach(function(cb) {
//			if (checkedCount >= 3 && !cb.checked) {
//				cb.disabled = true;
//				checkeParent.classList.add('is-disabled');
//			} else {
//				cb.disabled = false;
//				checkeParent.classList.remove('is-disabled');
//			}
//		});
//	}

	// チェックボックスの制限
	const limitNum = 3;
	const limitCheckWrap = document.querySelectorAll('.js-check-limit');
	const addOtherArray = ['z23', 'a23', 'b25', 'c31', 'd36', 'e28', 'f1', 'h23', 'i25', 'j31', 'k36', 'l28', 'm1'];

	limitCheckWrap.forEach((item) => {
		let limitCheckboxes = item.querySelectorAll('input[type="checkbox"]');

		limitCheckboxes.forEach(function(checkbox) {
			checkbox.addEventListener('change', function() {
				checkBoxFunc( item, limitCheckboxes, checkbox );
			});
			checkBoxFunc( item, limitCheckboxes, checkbox );
		});

	});

	function checkBoxFunc( classWrap, events, event ) {
		let checkedCount = classWrap.querySelectorAll('input[type="checkbox"]:checked').length;
		let checkeParent = event.closest('.js-check-limit');

		let checkedValue = event.value;
		let target = classWrap.querySelector('.' + checkedValue);

		if ( target ) {
			if ( event.checked && addOtherArray.includes(checkedValue) ) {
				target.classList.add('is-active');
			} else {
				target.classList.remove('is-active');
			}
		}


		events.forEach(function(cb) {
			if (checkedCount >= limitNum && !cb.checked) {
				cb.disabled = true;
				checkeParent.classList.add('is-disabled');
			} else {
				cb.disabled = false;
				checkeParent.classList.remove('is-disabled');
			}
		});
	}


	// セレクトによって子階層の内容を出す
	let parentSelect = document.querySelectorAll('.js-parent-select');

	parentSelect.forEach(function(selected) {
		selected.addEventListener('change', (e) => {
			selectedFunc( selected );

			// 選択肢変更時に追加リセット
			let selectName = selected.getAttribute('name');
			let children = document.getElementById(selectName);
			let childrenCheckbox = children.querySelectorAll('input[type="checkbox"]');
			childrenCheckbox.forEach((item) => {
				item.disabled = false;
				item.closest('.js-check-limit').classList.remove('is-disabled');
				item.checked = false;
			});
			// テキストエリアもリセットする
			let textarea = children.querySelector('textarea');
			textarea.classList.remove('is-active');
			textarea.value = '';
		});

		selectedFunc( selected );

		selected.querySelector('option[value=""]').textContent = '選択してください';
	});

	function selectedFunc( event ) {
		let selectName = event.getAttribute('name');
		let children = document.getElementById(selectName);
		let value = event.options[event.selectedIndex].value;

		if ( value != '' ) {
			children.classList.add('is-active');
		} else {
			children.classList.remove('is-active');
		}

		// セレクトによって選択肢を表示／非表示する
		let childrenCheckbox = children.querySelectorAll('input[type="checkbox"]');
		let childrenCheckboxTarget = children.querySelectorAll('input[value^="' + value + '"]');

		// リセット
		childrenCheckbox.forEach((item) => {
			let target = item.closest('.mwform-checkbox-field');
			target.style.display = '';
		});

		childrenCheckboxTarget.forEach((item) => {
			let target = item.closest('.mwform-checkbox-field');
			target.style.display = 'inline-block';
		});
	}


} );

